export const appName = 'notices';

export const noticesQueryBase = {
	_limit: '20',
	include: 'organizations,teams,roles',
};
